import {
  Alert,
  Autocomplete,
  Button,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Snackbar,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
//import { useState } from "react";
//import CreateChains from "../Modal/CreateChains";
import "./LogFilters.css";
import LogFiltersItems from "./LogFiltersItems";
import { useEffect, useState } from "react";
import RunNewProcessLog from "../Modal/RunNewProcessLog";
import store from "../../../../../store";
import {
  selectUserData,
  setIsLoading,
} from "../../../../../features/userSlice";
import { ETLLogsEndPointLogic } from "../../../../../logic/Admin/ETLChains/ETLLogsEndPointLogic";
import { useSelector } from "react-redux";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useNavigate, useLocation } from "react-router-dom";
import { CheckPermissions } from "../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { saveAs } from "file-saver";
interface props {
  tableHeadings: any;
  setRefresh: any;
  logs: any;
  setLogs: any;
  setSelectedStatus: any;
  selectedStatus: any;
  selectedMethod: any;
  setSelectedMethod: any;
  setFilteredLogsByLastRun: any;
  selectedIds: any;
  token: any;
  setSelectedIds: any;
  selectedName: any;
  setSelectedName: any;
  page: any;
  setPage: any;
  websiteSharedUid: any;
  setSelectedLastRun: any;
  selectedLastRun: any;
  setRowID: any;
  setProcessId: any;
  setIsClearFilter: any;
  setShowLastRunOnly: any;
  showLastRunOnly: any;
  setFilteredLogs: any;
  refresh: any;
  setProcesses: any;
  processes: any;
  selectedRows: any;
}

const LogFilters = ({
  tableHeadings,
  refresh,
  setRefresh,
  logs,
  setLogs,
  setSelectedStatus,
  selectedStatus,
  setSelectedMethod,
  selectedMethod,
  setFilteredLogsByLastRun,
  selectedIds,
  token,
  setSelectedIds,
  setSelectedName,
  setPage,
  websiteSharedUid,
  setSelectedLastRun,
  selectedLastRun,
  setRowID,
  setProcessId,
  selectedName,
  setIsClearFilter,
  setShowLastRunOnly,
  showLastRunOnly,
  setFilteredLogs,
  setProcesses,
  processes,
  selectedRows,
}: props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  // const [showLastRunOnly, setShowLastRunOnly] = useState(false);
  const [runStatus, setRunStatus] = useState(false) as any;
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);
 
  const uniqueProcessNames = Array.from(
    new Set(
      (processes?.ETL_PROCESS_NAME || [])
        // .filter((log: any) => !log.label.toLowerCase().includes("argo"))
        .map((log: any) => log.label)
    )
  );

  const specialProcessLogIds =
    import.meta.env.VITE_ENV === "development" ||
    import.meta.env.VITE_ENV === "staging"
      ? [72, 48, 69]
      : [33, 59];
  const response = useSelector(selectUserData);
  const hasRunProcessLogPermission = CheckPermissions(
    response?.data?.products?.admin,
    "processes",
    "run_manual_processes"
  );
  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleShowLastLogs = () => {
    setShowLastRunOnly(!showLastRunOnly);
    setPage(0);
    setRowID(null);
    if (!showLastRunOnly) {
      const groupedLogs = logs.reduce((acc: any, log: any) => {
        const { process_id } = log;
        if (!acc[process_id]) {
          acc[process_id] = log; // first entry for the process_id
        } else {
          if (new Date(log.start_time) > new Date(acc[process_id].end_time)) {
            acc[process_id] = log; // update if the current log has a later end_time
          }
        }
        return acc;
      }, {});

      // Convert the object back to an array
      const latestLogs = Object.values(groupedLogs);
      setFilteredLogsByLastRun(latestLogs);
    } else {
      // Show all logs if "Last run only" is turned off
      setFilteredLogsByLastRun(logs);
      setPage(0);
    }
  };

  const runProcess = async () => {
    const ids = { ids: selectedIds };
    try {
      if (selectedIds) {
        store.dispatch(setIsLoading(true));
        // setLoading(true);
        await ETLLogsEndPointLogic.runProcess(token, ids, setRunStatus);
        setSelectedIds([]);
        setSnackbarMessage("Process Run Successfully");
        setRefresh(true);
        setSnackbarOpen(true);
      } else {
        setRunStatus("User don`t have permission");
      }
    } catch (error) {
      setRunStatus(error);
    } finally {
      store.dispatch(setIsLoading(false));
    }
  };

  const handleRefresh = () => {
    setRefresh(!refresh);
    setRowID(null);
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.delete("page");
    navigate(`${location.pathname}?${newSearchParams.toString()}`, {
      replace: true,
    });
  };

  useEffect(() => {
    const searchQuery = searchParams.get("search");

    if (searchQuery) {
      const selectedProcess = (processes?.ETL_PROCESS_NAME || []).find(
        (process: any) => process?.id === Number(searchQuery)
      );
      setSelectedName(searchQuery);
      if (selectedProcess) {
        setSelectedName(selectedProcess?.label);
        setProcessId(selectedProcess?.id);
      } else {
        setSelectedName(null);
        setProcessId(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processes]);

  const isFilterApplied = () => {
    return (
      (selectedStatus && selectedStatus?.length > 0) ||
      (selectedMethod && selectedMethod?.length > 0) ||
      (selectedLastRun && selectedLastRun[0] && selectedLastRun[1]) ||
      (selectedName && selectedName !== null)
    );
  };

  
  // -- Function to export CSV
  // const handleExportCSV = async() => {
  //  await fetchLogs(1000);
  //   const csvRows = [];
  //    // Prepare headers (exclude 'info' and 'response')
  // const tableHeaders = Object.entries(tableHeadings)
  //   .filter(([key]) => key !== "info" && key !== "response")
  //   .map(([key, label], index) => ({
  //     id: index + 1,
  //     KEY: key,
  //     label,
  //     sortable: true,
  //   }));

  //   const newheaders = [...tableHeaders]; // make a copy of original array of tableheaders to add the new message field

  //   // Extract the table headers
  //   const headers = newheaders.map((pair) => pair.label) as any;
  //   csvRows.push(headers.join(","));

  //  logs.forEach((log:any) => {
  //   const row = newheaders.map(({ KEY }) => {
  //     const value = log[KEY];
  //     return value === null || value === undefined ? "" : value;
  //   });
  //   csvRows.push(row.join(","));
  // });

  //   // Convert CSV rows to a single string
  //   const csvString = csvRows.join("\n");

  //   // Create a blob and download the file
  //   const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  //   saveAs(blob, "Admin-ETLProccessLogs.csv");
  // };
   const handleExportCSV = async () => {
    setExportLoader(true);
    const rpp = 1000; // Set records per page to a high number for export
    await ETLLogsEndPointLogic.getLogsForExport(token, setLogs, rpp);
    setExportLoader(false);
    setIsExporting(true);
};

  useEffect(() => {
    if (!isExporting || logs.length === 0) return;

    // Now logs are updated in parent and passed to child
    const csvRows = [];

    const tableHeaders = Object.entries(tableHeadings)
      .filter(([key]) => key !== "info" && key !== "response")
      .map(([key, label], index) => ({
        id: index + 1,
        KEY: key,
        label,
        sortable: true,
      }));

    const headers = tableHeaders.map((pair) => pair.label);
    csvRows.push(headers.join(","));

    logs.forEach((log:any) => {
      const row = tableHeaders.map(({ KEY }) => {
        const value = log[KEY];
        return value === null || value === undefined ? "" : value;
      });
      csvRows.push(row.join(","));
    });

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "Admin-ETLProccessLogs.csv");

    // Reset the flag after export
    setIsExporting(false);
  }, [logs, isExporting, tableHeadings]);

  return (
    <>
      <Paper className="chainsFiltersWrap">
        <div style={{ padding: "16px" }}>
          {/* Heading */}
          <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <Grid item xs={8}>
              <Typography variant="h3" sx={{ fontSize: "24px" }}>
                Logs
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                Create new or edit existing ETL Process Logs.
              </Typography>
            </Grid>
            <Grid item xs={4} textAlign={"end"}>
              <FormControlLabel
                data-tracker="225"
                value="LastRunOnly"
                control={
                  <Switch color="secondary" onClick={handleShowLastLogs} />
                }
                label="Last run only"
                labelPlacement="start"
              />
              <Typography sx={{ display: "inline", mr: 1, ml: 4 }}>
                Bulk Actions:
              </Typography>
              {hasRunProcessLogPermission ? (
                <IconButton
                  color="secondary"
                  disabled={
                    (selectedIds && selectedIds.length === 0) ||
                    selectedIds?.some(
                      (id: number) =>
                        specialProcessLogIds.includes(id) ||
                        // here we need to check if in the array of object selectedRows there is any object whose status is "PENDING" or "RUNNING" if yes then disable the button
                        selectedRows.length === 0 ||
                        selectedRows.some(
                          (row: any) =>
                            row.status === "PENDING" ||
                            row.status === "RUNNING",
                        ),
                    )
                  }
                  onClick={runProcess}
                >
                  <PlayCircleFilledWhiteIcon data-tracker="227" />
                </IconButton>
              ) : (
                <IconButton disabled>
                  <PlayCircleFilledWhiteIcon />
                </IconButton>
              )}
              <IconButton color="secondary" disabled={!logs || logs.length === 0 || exportLoader}>
                <FileDownloadIcon
                  data-tracker="226"
                  onClick={handleExportCSV}
                  className={exportLoader ? 'bounce-download' : ''}
                />
              </IconButton>
            </Grid>
          </Grid>

          {/* Filter part */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                marginTop: "5px",
              }}
            >
              {/*Process Names */}
              <Autocomplete
                data-tracker="223"
                options={
                  uniqueProcessNames ? uniqueProcessNames.filter(Boolean) : []
                }
                value={selectedName || null}
                onChange={(_, newValue) => {
                  if (newValue) {
                    const selectedProcess = (processes?.ETL_PROCESS_NAME || []).find(
                      (process: any) => process.label === newValue
                    );
                    if (selectedProcess) {
                      setProcessId(selectedProcess.id);
                      setPage(0);
                      setSelectedName(newValue);

                      // Update the URL search parameter with the process id
                      const newSearchParams = new URLSearchParams(
                        location.search
                      );
                      setRowID(null);
                      newSearchParams.set("search", selectedProcess?.id);
                      newSearchParams.delete("run_id");
                      setPage(0);
                      newSearchParams.set("page", "0");
                      navigate(
                        `${location.pathname}?${newSearchParams.toString()}`,
                        { replace: true }
                      );
                    }
                  } else {
                    // Clear the search param if no value selected
                    const newSearchParams = new URLSearchParams(
                      location.search
                    );
                    setRowID(null);
                    newSearchParams.delete("search");
                    navigate(
                      `${location.pathname}?${newSearchParams.toString()}`,
                      { replace: true }
                    );
                    setSelectedName(null);
                    setProcessId(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Process Name"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ marginLeft: "12px" }} />
                        </InputAdornment>
                      ),
                    }}
                    color="secondary"
                  />
                )}
                size="small"
                sx={{ width: "300px" }}
              />

              <LogFiltersItems
                logs={logs}
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                setSelectedMethod={setSelectedMethod}
                selectedMethod={selectedMethod}
                setSelectedLastRun={setSelectedLastRun}
                selectedLastRun={selectedLastRun}
                setRowID={setRowID}
                setProcessId={setProcessId}
                setSelectedName={setSelectedName}
                setPage={setPage}
                setIsClearFilter={setIsClearFilter}
                setFilteredLogs={setFilteredLogs}
                isFilterApplied={isFilterApplied}
                setRefresh={setRefresh}
              />
            </div>
            {/* Action Buttons */}
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <Tooltip title="Refresh">
                <RefreshIcon
                  data-tracker="224"
                  onClick={handleRefresh}
                  color="secondary"
                  sx={{ cursor: "pointer" }}
                />
              </Tooltip>
              <Button
                data-tracker="228"
                variant="contained"
                color="secondary"
                endIcon={<PlayCircleFilledWhiteIcon />}
                onClick={handleOpen}
              >
                run new Process
              </Button>
              <RunNewProcessLog
                openModal={openModal}
                onCloseModal={handleClose}
                token={token}
                setRefresh={setRefresh}
                websiteSharedUid={websiteSharedUid}
                setProcesses={setProcesses}
                processes={processes}
                setRowID={setRowID}
              />
            </div>
          </div>
        </div>
      </Paper>
      {(runStatus === "Created." || runStatus === "Success.") && (
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={"success"}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};
export default LogFilters;
